import React, { useEffect, useState } from 'react'
import { Outlet } from 'react-router-dom'
import { Sidebar } from '../MenuLateral'
import ky from 'ky'

import {
  MailOutline,
  PeopleOutline,
  Campaign,
  Description,
  EmojiEvents,
  Person,
} from '@mui/icons-material'

import { AccessModule } from '../MenuLateral/types'
import { MenuItem, SubTitle } from './types'

const { REACT_APP_API_URL } = process.env

const initialMenus: MenuItem[] = [
  {
    id: 1,
    title: 'Atendimento',
    icon: <MailOutline fontSize="medium" />,
    subTitles: [
      { id: 101, text: 'Mensagens', url: '/mensagens' },
      { id: 102, text: 'Canais',     url: '/canais'     },
    ],
  },
  {
    id: 2,
    title: 'Proprietários',
    icon: <PeopleOutline fontSize="medium" />,
    url:  '/proprietarios',
  },
  {
    id: 3,
    title: 'Comunicados',
    icon: <Campaign fontSize="medium" />,
    url:  '/comunicados',
  },
  {
    id: 4,
    title: 'Documentos',
    icon: <Description fontSize="medium" />,
    subTitles: [
      { id: 401, text: 'Lista de documentos', url: '/arquivos' },
      { id: 402, text: 'Categorias',          url: '/arquivos/categorias' },
    ],
  },
  {
    id: 5,
    title: 'Programa de fidelidade',
    icon: <EmojiEvents fontSize="medium" />,
    subTitles: [
      { id: 501, text: 'Pontos',      url: '/Pontos' },
      { id: 502, text: 'Benefícios',  url: '/programa-de-fidelidade' },
    ],
  },
  {
    id: 6,
    title: 'Gestão de usuários',
    icon: <Person fontSize="medium" />,
    url:  '/gestao-usuarios',
  },
]

export const Layout: React.FC = () => {
  const [menus, setMenus] = useState<MenuItem[]>(initialMenus)
  const [networkUnitId, setNetworkUnitId] = useState<string | null>(
    localStorage.getItem('selectedNetwork')
  )

  useEffect(() => { fetchMenus() }, [networkUnitId])

  useEffect(() => {
    const onStorage = (e: StorageEvent) => {
      if (e.key === 'selectedNetwork') setNetworkUnitId(e.newValue)
    }
    window.addEventListener('storage', onStorage)
    return () => window.removeEventListener('storage', onStorage)
  }, [])

  async function getHeaders(contentType?: string) {
    const headers: Record<string, string> = { Accept: 'application/json' }
    const token = localStorage.getItem('token')
    if (token) headers.Authorization = `Bearer ${token}`
    if (contentType) headers['Content-Type'] = contentType
    return headers
  }

  async function fetchMenus() {
    const userId = localStorage.getItem('userId')
    const netId  = localStorage.getItem('selectedNetwork')
    if (userId && netId) await fetchAccessModules(+userId, +netId)
  }

  async function fetchAccessModules(userId: number, netId: number) {
    try {
      const url     = `${REACT_APP_API_URL}user/user-permissions/${netId}/${userId}`
      const headers = await getHeaders()
      const data: AccessModule[] = await ky.get(url, { headers }).json()
      setMenus(filterMenus(data))
    } catch (err) {
      console.error('Erro ao buscar módulos', err)
    }
  }

  function filterMenus(access: AccessModule[]): MenuItem[] {
    const activeIds = access.filter(m => m.Active).map(m => m.AccessModuleId)

    return initialMenus.reduce<MenuItem[]>((acc, menu) => {
      const mainActive = activeIds.includes(menu.id)
      const subs: SubTitle[] | undefined = menu.subTitles
        ?.filter(s => activeIds.includes(s.id))

      if (mainActive || (subs && subs.length > 0)) {
        acc.push({ ...menu, subTitles: subs })
      }
      return acc
    }, [])
  }

  return (
    <div className="flex h-screen">
      <Sidebar menus={menus} />
      <main className="flex-1 overflow-y-auto">
        <Outlet />
      </main>
    </div>
  )
}

export default Layout
